"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/admin_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAccountService = void 0;
const admin_service_pb_1 = require("./admin_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.account.v1.AdminAccountService
 */
exports.AdminAccountService = {
    typeName: "spwn.account.v1.AdminAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.GetAdminUsers
         */
        getAdminUsers: {
            name: "GetAdminUsers",
            I: admin_service_pb_1.AdminAccountServiceGetAdminUsersRequest,
            O: admin_service_pb_1.AdminAccountServiceGetAdminUsersResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.SetAdminUserDisabled
         */
        setAdminUserDisabled: {
            name: "SetAdminUserDisabled",
            I: admin_service_pb_1.AdminAccountServiceSetAdminUserDisabledRequest,
            O: admin_service_pb_1.AdminAccountServiceSetAdminUserDisabledResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.SetAdminUserRole
         */
        setAdminUserRole: {
            name: "SetAdminUserRole",
            I: admin_service_pb_1.AdminAccountServiceSetAdminUserRoleRequest,
            O: admin_service_pb_1.AdminAccountServiceSetAdminUserRoleResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.SetAdminUserIsRedeemer
         */
        setAdminUserIsRedeemer: {
            name: "SetAdminUserIsRedeemer",
            I: admin_service_pb_1.AdminAccountServiceSetAdminUserIsRedeemerRequest,
            O: admin_service_pb_1.AdminAccountServiceSetAdminUserIsRedeemerResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.AddAdminUser
         */
        addAdminUser: {
            name: "AddAdminUser",
            I: admin_service_pb_1.AdminAccountServiceAddAdminUserRequest,
            O: admin_service_pb_1.AdminAccountServiceAddAdminUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.DeleteAdminUser
         */
        deleteAdminUser: {
            name: "DeleteAdminUser",
            I: admin_service_pb_1.AdminAccountServiceDeleteAdminUserRequest,
            O: admin_service_pb_1.AdminAccountServiceDeleteAdminUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.GetCreators
         */
        getCreators: {
            name: "GetCreators",
            I: admin_service_pb_1.AdminAccountServiceGetCreatorsRequest,
            O: admin_service_pb_1.AdminAccountServiceGetCreatorsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.GetTenantOwnerBySlug
         */
        getTenantOwnerBySlug: {
            name: "GetTenantOwnerBySlug",
            I: admin_service_pb_1.AdminAccountServiceGetTenantOwnerBySlugRequest,
            O: admin_service_pb_1.AdminAccountServiceGetTenantOwnerBySlugResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.GetCreatorsBySlug
         */
        getCreatorsBySlug: {
            name: "GetCreatorsBySlug",
            I: admin_service_pb_1.AdminAccountServiceGetCreatorsBySlugRequest,
            O: admin_service_pb_1.AdminAccountServiceGetCreatorsBySlugResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.AddCreatorToTenant
         */
        addCreatorToTenant: {
            name: "AddCreatorToTenant",
            I: admin_service_pb_1.AdminAccountServiceAddCreatorToTenantRequest,
            O: admin_service_pb_1.AdminAccountServiceAddCreatorToTenantResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.RemoveCreatorFromTenant
         */
        removeCreatorFromTenant: {
            name: "RemoveCreatorFromTenant",
            I: admin_service_pb_1.AdminAccountServiceRemoveCreatorFromTenantRequest,
            O: admin_service_pb_1.AdminAccountServiceRemoveCreatorFromTenantResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.GetBrands
         */
        getBrands: {
            name: "GetBrands",
            I: admin_service_pb_1.AdminAccountServiceGetBrandsRequest,
            O: admin_service_pb_1.AdminAccountServiceGetBrandsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.GetAccessibleBrands
         */
        getAccessibleBrands: {
            name: "GetAccessibleBrands",
            I: admin_service_pb_1.AdminAccountServiceGetAccessibleBrandsRequest,
            O: admin_service_pb_1.AdminAccountServiceGetAccessibleBrandsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.GetBrandBySlug
         */
        getBrandBySlug: {
            name: "GetBrandBySlug",
            I: admin_service_pb_1.AdminAccountServiceGetBrandBySlugRequest,
            O: admin_service_pb_1.AdminAccountServiceGetBrandBySlugResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.AddBrandToTenant
         */
        addBrandToTenant: {
            name: "AddBrandToTenant",
            I: admin_service_pb_1.AdminAccountServiceAddBrandToTenantRequest,
            O: admin_service_pb_1.AdminAccountServiceAddBrandToTenantResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.UpdateBrandProfile
         */
        updateBrandProfile: {
            name: "UpdateBrandProfile",
            I: admin_service_pb_1.AdminAccountServiceUpdateBrandProfileRequest,
            O: admin_service_pb_1.AdminAccountServiceUpdateBrandProfileResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.AddTenantUser
         */
        addTenantUser: {
            name: "AddTenantUser",
            I: admin_service_pb_1.AdminAccountServiceAddTenantUserRequest,
            O: admin_service_pb_1.AdminAccountServiceAddTenantUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.AddBrandUser
         */
        addBrandUser: {
            name: "AddBrandUser",
            I: admin_service_pb_1.AdminAccountServiceAddBrandUserRequest,
            O: admin_service_pb_1.AdminAccountServiceAddBrandUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.DeleteBrandUser
         */
        deleteBrandUser: {
            name: "DeleteBrandUser",
            I: admin_service_pb_1.AdminAccountServiceDeleteBrandUserRequest,
            O: admin_service_pb_1.AdminAccountServiceDeleteBrandUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.DeleteTenantUser
         */
        deleteTenantUser: {
            name: "DeleteTenantUser",
            I: admin_service_pb_1.AdminAccountServiceDeleteTenantUserRequest,
            O: admin_service_pb_1.AdminAccountServiceDeleteTenantUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.SearchTenantUsers
         */
        searchTenantUsers: {
            name: "SearchTenantUsers",
            I: admin_service_pb_1.AdminAccountServiceSearchTenantUsersRequest,
            O: admin_service_pb_1.AdminAccountServiceSearchTenantUsersResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.AdminAccountService.SearchBrandUsers
         */
        searchBrandUsers: {
            name: "SearchBrandUsers",
            I: admin_service_pb_1.AdminAccountServiceSearchBrandUsersRequest,
            O: admin_service_pb_1.AdminAccountServiceSearchBrandUsersResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=admin_service_connect.js.map